$(window).on("load", function () {
	const body = $("body");
	const searchbtn = $("#search-toggle");
	const menubtn = $("#menu-toggle");
	const subsbtn = $("#main-nav .wj-item-toggle");
	const menunav = $("#main-nav");

	$("#menu-toggle, #main-nav > .menu-control").on("click",
		function () {
			togglePrimaryNav();
		}
	);
	$(".sub-menu .menu-control").on("click",
		function () {
			closeAllSubPanels();
		}
	);
	$("#search-toggle").on("click",
		function () {
			if ($(window).width() < 1000) {
				toggleSearchNav();
			}
		}
	);
	$("#search-toggle").hover(
		function () {
			if ($(window).width() > 999) {
				hoverSearchNav();
			}
		}
	);
	$("#main-nav .wj-item-toggle").on("click",
		function (e) {
			e.preventDefault();
			closeAllSubPanels();
			let container = $(this).closest('li');
			let myPanel = container.find('.sub-menu.panel-navigation');
			myPanel.addClass("active");
		}
	);
	$(window).on('resize',
		function () {
			resetAndClose();
		}
	);

	function resetAndClose() {
		body.removeClass("fixed");
		menubtn.removeClass("open");
		menunav.removeClass("toggle-open");
		menunav.attr("aria-expanded", "false");
	}

	function togglePrimaryNav() {
		if (menubtn.hasClass("open")) {
			resetAndClose();
		} else {
			body.addClass("fixed");
			menubtn.addClass("open");
			menunav.addClass("toggle-open");
			menunav.attr("aria-expanded", "true");
		}
		$('.sub-menu.panel-navigation').removeClass("active");
	}
	function toggleSearchNav() {
		closeAllSubPanels()
		$('.sub-menu.panel-search').addClass("active");

		body.addClass("fixed");
		menubtn.addClass("open");
		menunav.addClass("toggle-open");
		menunav.attr("aria-expanded", "true");
	}
	function hoverSearchNav() {
		$('.sub-menu.panel-search').toggleClass("active");
	}
	function closeAllSubPanels() {
		$('.sub-menu.panel-navigation').removeClass("active");
	}


	$(".sub-menu a").focus(function () {
		$(this).parents('.sub-menu.panel-navigation').addClass('active');
	}).blur(function () {
		$(this).parents('.sub-menu.panel-navigation').removeClass("active");
	});

	$('.wp-block-search .wp-block-search__button').each(function () {
		$(this).append('<i class="ico-wjc-search"></i>');
	});



	$('#social-nav li a').each(function () {
		var icon = '';
		var link = $(this).attr('href').toString();

		if (link.includes('#')) {
			icon = 'youtube';
			$(this).prop('title', 'Watch us on YouTube.')
		};

		if (link.includes('youtube')) {
			icon = 'youtube';
			$(this).prop('title', 'Watch us on YouTube.')
		};

		if (link.includes('facebook')) {
			icon = 'facebook';
			$(this).prop('title', 'Connect with us on Facebook.')
		};

		if (link.includes('mailto')) {
			icon = 'email';
			$(this).prop('title', 'Contact us through Email.')
		};

		if (link.includes('contact')) {
			icon = 'email';
			$(this).prop('title', 'Contact us through Email.')
		};

		if (link.includes('instagram')) {
			icon = 'instagram';
			$(this).prop('title', 'Connect with us on Instagram.')
		};

		if (link.includes('linkedin')) {
			icon = 'linkedin';
			$(this).prop('title', 'Connect with us on LinkedIn.')
		};

		if (link.includes('pinterest')) {
			icon = 'pinterest';
			$(this).prop('title', 'Connect with us on Pinterest.')
		};

		if (link.includes('rss')) {
			icon = 'rss';
			$(this).prop('title', 'Connect with us through our RSS Feed.')
		};

		if (link.includes('twitter')) {
			icon = 'twitter';
			$(this).prop('title', 'Connect with us through Twitter.')
		};

		if (link.includes('vimeo')) {
			icon = 'vimeo';
			$(this).prop('title', 'Watch us on Vimeo.')
		};

		if (icon) {
			$(this).html("<svg class='icon " + icon + "'><use xlink:href='#wjico_" + icon + "' /></svg>");
		}

	});


	$("body:not(.header-landing) #secondary-nav .mobile-secondary-toggle span.label")
		.html($(".breadcrumb_last").text());
	$("body:not(.header-landing) #secondary-nav .mobile-secondary-toggle").on('click', function (e) {
		$(this).siblings('li').slideToggle('10');
	});


	$('img.featured-image-default').closest('figure').addClass('default');


});
